.placeholder {
	--placeholder-width: 100%;
	position: relative;
	display: block;
	z-index: 3;

	> * {
		height: 100%;
	}
	&.active {
		width: var(--placeholder-width);
		// height: 100%;
		&:after {
			opacity: 1;
			user-select: all;
			pointer-events: all;
			animation: placeholder 1.5s ease-in-out infinite;
		}
	}
	&:after {
		content: "";
		position: absolute;
		inset: 0;
		opacity: 0;
		user-select: none;
		pointer-events: none;
		background: #fbfbfb;
		z-index: 10;
		border-radius: 5px;
	}
}

@keyframes placeholder {
	50% {
		background: darken(#fbfbfb, 5%);
	}
}
